import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcInfo24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 2a9.99 9.99 0 0 1 10 10 9.99 9.99 0 0 1 -10 10 9.99 9.99 0 0 1 -10-10 9.99 9.99 0 0 1 10-10zm0 2c-4.438 0-8 3.563-8 8 0 4.406 3.594 8 8 8s8-3.594 8-8c0-4.438-3.594-8-8-8zm0 6h-1.938c-.562 0-1 .469-1 1s.438 1 1 1h.938v3h-1c-.531 0-1 .438-1 1 0 .531.469 1 1 1h4.031c.531 0 .969-.469.969-1s-.438-1-.969-1h-1.031v-4c0-.563-.406-1-1-1zm0-4c-.688 0-1.25.531-1.25 1.219 0 .718.563 1.25 1.25 1.25.688 0 1.25-.531 1.25-1.25 0-.689-.563-1.219-1.25-1.219z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcInfo24;
